import RailsResource from "./rails-resource";

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'online-class',
      ajaxLoader: true
    });
  }

  leaves(appointmentId, attendanceId) {
    return this.post(`${this.url}/${this.resource}/${appointmentId}/event/${attendanceId}/leaves`, true);
  }
}